/* Kofi B2B funnel telemetry. No form values or PII are sent to analytics. */
(() => {
  'use strict';
  const root = document.getElementById('kfb');
  if (!root || window.kofiB2BTracking) return;
  const preview = root.dataset.telemetryDisabled === 'true' || root.dataset.preview === 'true' || new URLSearchParams(location.search).has('preview_theme_id') || !!(window.Shopify && (window.Shopify.designMode || window.Shopify.previewMode || (window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main')));
  const PIXEL = '807038199864129';
  const GA = 'G-1RPGBQ9GCD';
  const KEY = 'kofi-firmenkaffee-request-v3';
  const TTL = 60 * 60 * 1000;
  const params = new URLSearchParams(location.search);
  const isTest = params.get('kfb_test') === '1';
  const stages = new Set();
  const sent = new Set();
  let confirmed = false;
  let memoryPending = null;
  let metaReady = false;
  let gaReady = false;
  const read = key => { try { return JSON.parse(sessionStorage.getItem(key)); } catch (_) { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) { /* Form remains usable. */ } };
  const allowed = kind => {
    try {
      const p = window.Shopify && window.Shopify.customerPrivacy;
      return !!p && (kind === 'meta' ? p.marketingAllowed() === true : p.analyticsProcessingAllowed() === true);
    } catch (_) { return false; }
  };
  const pending = () => memoryPending || read(KEY);
  const valid = p => p && typeof p.id === 'string' && /^[a-zA-Z0-9-]{8,80}$/.test(p.id) && typeof p.time === 'number' && Date.now() >= p.time && Date.now() - p.time < TTL;
  const cleanLocation = () => {
    const url = new URL('https://kofi.de/pages/firmenkaffee');
    // Only our fixed campaign labels and numeric delivery IDs. Never forward arbitrary URL input.
    for (const name of ['utm_source','utm_medium','utm_campaign','utm_content','campaign_id','adset_id','ad_id','placement']) {
      const value = params.get(name) || '';
      if (/^[a-zA-Z0-9_-]{1,100}$/.test(value)) url.searchParams.set(name,value);
    }
    return url.href;
  };
  const meta = (event, data, id) => {
    if (!metaReady) {
      if (!window.fbq) {
        const fbq = window.fbq = function(){fbq.callMethod ? fbq.callMethod.apply(fbq,arguments) : fbq.queue.push(arguments);};
        window._fbq = fbq; fbq.queue=[]; fbq.loaded=true; fbq.version='2.0';
        const script=document.createElement('script');script.async=true;script.src='https://connect.facebook.net/en_US/fbevents.js';document.head.appendChild(script);
      }
      // Theme window and Shopify's app-pixel sandbox are separate. Do not broadcast to other pixels.
      if (!window.__kofiB2BPixelInitialized) { window.fbq('init',PIXEL); window.__kofiB2BPixelInitialized=true; }
      window.fbq('set','autoConfig',false,PIXEL);
      metaReady=true;
    }
    window.fbq(event==='Lead'?'trackSingle':'trackSingleCustom',PIXEL,event,data,{eventID:id});
  };
  const ga = (event, data) => {
    if (!gaReady) {
      // Dedicated queue: Shopify's Google app runs in its own sandbox. No duplicate page_view.
      window.kofiB2BDataLayer = window.kofiB2BDataLayer || [];
      window.kofiB2BGtag = function(){window.kofiB2BDataLayer.push(arguments);};
      window.kofiB2BGtag('js',new Date());
      window.kofiB2BGtag('config',GA,{send_page_view:false,allow_google_signals:false,allow_ad_personalization_signals:false,page_location:cleanLocation(),page_referrer:''});
      const script=document.createElement('script');script.async=true;script.src='https://www.googletagmanager.com/gtag/js?id='+GA+'&l=kofiB2BDataLayer';document.head.appendChild(script);
      gaReady=true;
    }
    window.kofiB2BGtag('event',event,{...data,send_to:GA,page_location:cleanLocation(),page_referrer:''});
  };
  const names = {view:['KofiB2BView','kofi_b2b_view'],start:['KofiB2BFormStart','kofi_b2b_form_start'],step2:['KofiB2BFormStep2','kofi_b2b_form_step2'],lead:['Lead','generate_lead']};
  const emit = stage => {
    if (preview || isTest) return;
    const p = pending();
    if (stage === 'lead' && (!confirmed || !valid(p) || p.test)) return;
    for (const channel of ['meta','ga']) {
      const marker = stage==='lead' ? 'kofi-b2b-'+channel+'-'+p.id : channel+'-'+stage;
      if (!allowed(channel) || sent.has(marker) || (stage==='lead' && read(marker))) continue;
      const payload={funnel_id:'kofi_firmenkaffee',content_name:'Firmenkaffee Anfrage',content_category:'B2B'};
      const id=stage==='lead'?p.id:undefined;
      try {
        if(channel==='meta') meta(names[stage][0],payload,id);
        else ga(names[stage][1],payload);
        sent.add(marker);
        if(stage==='lead') write(marker,true);
      } catch (_) { /* Retry on next consent signal; never prevent a form submission. */ }
    }
  };
  const flush = () => { for(const stage of stages) emit(stage); };
  const reach = stage => { if(!names[stage] || stage==='lead') return; stages.add(stage);emit(stage); };
  const prepare = form => {
    const p={id:window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`,time:Date.now(),test:isTest};
    memoryPending=p;write(KEY,p);
    const idField=form.querySelector('#kfb-request-id');if(idField) idField.value=p.id;
    const testField=form.querySelector('#kfb-test');if(testField) testField.value=isTest?'Technische Testanfrage, bitte nicht als Interessent behandeln':'';
    return p.id;
  };
  const confirm = () => {
    if (!root.querySelector('#kfb-success')) return;
    confirmed=true;stages.add('lead');emit('lead');
    const p=pending();
    if(valid(p)) {
      const note=document.createElement('p');note.className='kfb-request-reference';note.textContent='Deine Anfrage-ID: '+p.id;
      root.querySelector('#kfb-success').appendChild(note);
    }
  };
  window.kofiB2BTracking={reach,prepare,confirm};
  document.addEventListener('visitorConsentCollected',flush);
  if (window.Shopify && typeof window.Shopify.loadFeatures==='function') {
    try { window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)flush();}); } catch (_) {}
  }
  if(!root.querySelector('#kfb-success')) reach('view');
})();

(() => {
  'use strict';
  const root = document.getElementById('kfb');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const preview = root.dataset.preview === 'true';
  const form = root.querySelector('form');
  const success = root.querySelector('#kfb-success');
  const privacy = () => window.Shopify && window.Shopify.customerPrivacy;
  const analyticsAllowed = () => { try { return privacy() && privacy().analyticsProcessingAllowed() === true; } catch (_) { return false; } };

  // Message match per ad: the Christmas ad gets a Christmas hero. Reads the URL only, stores nothing.
  const variantParams = new URLSearchParams(location.search);
  if (/weihnacht|danke/i.test(variantParams.get('utm_content') || '')) {
    const eyebrow = root.querySelector('[data-variant="eyebrow"]');
    const intro = root.querySelector('[data-variant="intro"]');
    const date = root.querySelector('#kfb-date');
    const customers = root.querySelector('input[name="contact[Anlass]"][value="Kundengeschenke"]');
    if (eyebrow) eyebrow.textContent = 'Weihnachtsgeschenke für deine Kunden';
    if (intro) intro.textContent = 'Danke für ein gutes Jahr. Mit deinem Logo drauf.';
    if (date) date.placeholder = 'z. B. Anfang Dezember';
    if (customers && !root.querySelector('input[name="contact[Anlass]"]:checked')) customers.checked = true;
  }

  if (form && !success) {
    const steps = [...form.querySelectorAll('[data-step]')];
    const next = form.querySelector('.kfb-next');
    const back = form.querySelector('.kfb-back');
    const progress = form.querySelector('.kfb-progress');
    const summary = form.querySelector('.kfb-selection-summary');
    const submit = form.querySelector('.kfb-submit');
    const feedback = form.querySelector('.kfb-form-feedback');
    let current = 1;
    let submitting = false;
    const inputs = step => [...steps[step - 1].querySelectorAll('input,select,textarea')];
    const showStep = (number, focus = true) => {
      current = number;
      steps.forEach((step, i) => { step.hidden = i !== number - 1; });
      progress.dataset.step = String(number);
      const label = progress.querySelector('p');
      label.replaceChildren(document.createTextNode(`Schritt ${number} von 2 `));
      const stage = document.createElement('span');
      stage.textContent = number === 1 ? 'Dein Projekt' : 'Deine Kontaktdaten';
      label.appendChild(stage);
      if (number === 2) {
        window.kofiB2BTracking?.reach('step2');
        const occasion = form.querySelector('input[name="contact[Anlass]"]:checked');
        summary.textContent = [occasion && occasion.value, form.querySelector('#kfb-quantity').value, form.querySelector('#kfb-date').value].filter(Boolean).join(' · ');
        summary.hidden = false;
      }
      if (focus) {
        form.scrollIntoView({block:'start',behavior:'auto'});
        inputs(number)[0].focus({preventScroll:true});
      }
    };
    const validate = number => {
      const invalid = inputs(number).find(input => !input.checkValidity());
      if (!invalid) return true;
      const detail = invalid.closest('details');
      if (detail) detail.open = true;
      invalid.reportValidity();
      return false;
    };
    form.noValidate = true; // Validate only visible controls, retaining native validation with JavaScript disabled.
    progress.hidden = false;
    next.hidden = false;
    back.hidden = false;
    if (preview) form.querySelector('.kfb-preview-note').hidden = false;
    showStep(1, false);
    next.addEventListener('click', () => { if (validate(1)) { showStep(2); } });
    back.addEventListener('click', () => showStep(1));
    root.querySelectorAll('[data-occasion]').forEach(link => link.addEventListener('click', () => {
      const choice = [...form.querySelectorAll('input[name="contact[Anlass]"]')].find(input => input.value === link.dataset.occasion);
      if (choice) choice.checked = true;
      showStep(1, false);
    }));
    const assignAttribution = () => {
      const allowed = analyticsAllowed();
      const params = new URLSearchParams(location.search);
      form.querySelectorAll('[data-utm]').forEach(field => {
        field.value = allowed ? (params.get(field.dataset.utm) || '').replace(/[\u0000-\u001f<>]/g, '').slice(0, 150) : '';
      });
    };
    form.addEventListener('change', () => window.kofiB2BTracking?.reach('start'), {once:true});
    assignAttribution();
    document.addEventListener('visitorConsentCollected', assignAttribution);
    form.addEventListener('submit', event => {
      if (submitting) { event.preventDefault(); return; }
      if (!validate(1)) { event.preventDefault(); showStep(1); validate(1); return; }
      if (current === 1) { event.preventDefault(); showStep(2); return; }
      if (!validate(2)) { event.preventDefault(); return; }
      assignAttribution();
      if (preview) {
        event.preventDefault();
        feedback.hidden = false;
        feedback.textContent = 'Die Vorschau ist geprüft. Es wurde keine Anfrage versendet. Auf der Shopify-Seite wird deine Anfrage direkt an kofi übermittelt.';
        feedback.focus();
        return;
      }
      if (window.kofiB2BTracking) window.kofiB2BTracking.prepare(form);
      submitting = true;
      submit.disabled = true;
      submit.textContent = 'Anfrage wird gesendet …';
      // Re-enable after blocked navigation / captcha timeout; never fabricate a success state.
      setTimeout(() => {
        submitting = false;
        submit.disabled = false;
        submit.textContent = 'Unverbindlich anfragen ↗';
        feedback.hidden = false;
        feedback.textContent = 'Noch keine Bestätigung? Bitte schließe gegebenenfalls die Sicherheitsprüfung ab. Falls das Senden nicht klappt, schreib uns an info@kofi.de.';
      }, 20000);
    });
    window.addEventListener('pageshow', () => {
      submitting = false;
      submit.disabled = false;
      submit.textContent = 'Unverbindlich anfragen ↗';
    });
  }

  if (success && !preview) {
    success.focus({preventScroll:true});
    success.scrollIntoView({block:'center',behavior:'auto'});
    if (window.kofiB2BTracking) window.kofiB2BTracking.confirm();
  }
  const sticky = root.querySelector('.kfb-sticky');
  const hero = root.querySelector('.kfb-hero');
  const inquiry = root.querySelector('#kfb-anfrage');
  if (sticky && 'IntersectionObserver' in window && !success) {
    let heroSeen = true, inquirySeen = false;
    const update = () => { sticky.hidden = heroSeen || inquirySeen; };
    new IntersectionObserver(entries => { heroSeen = entries[0].isIntersecting; update(); }).observe(hero);
    new IntersectionObserver(entries => { inquirySeen = entries[0].isIntersecting; update(); }).observe(inquiry);
  }
})();
